import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const PatientService = {
  GetAllPatients,
  IsEligiblePatient,
  GetPatientConfigData,
  LockPatient,
  IsLocked,
  SetPatientSubmitValue,
  UnlockPatient,
  GetPatientDataToExport,
  SaveZipFile,
  SavePatient,
    GetClinicalDates,
    DownloadFile
};

function GetAllPatients(centerId) {
  return WebServiceWrapper.Get(`/patient/GetAllPatients?centerId=${centerId}`);
}

function IsEligiblePatient(pid) {
  return WebServiceWrapper.Get(`/patient/IsPatientEligible?patientId=${pid}`);
}
function GetPatientConfigData(pid, partId) {
  return WebServiceWrapper.Get(`/patient/OnValidateSubmitClick?patientId=${pid}&partId=${partId}`);
}
function LockPatient(payload) {
  return WebServiceWrapper.Post("/patient/LockPatient", payload);
}
function IsLocked(pid) {
  return WebServiceWrapper.Get(`/patient/IsLocked?patientId=${pid}`);
}
function SetPatientSubmitValue(payload) {
  return WebServiceWrapper.Post("/patient/SetPatientSubmitValue", payload);
}
function UnlockPatient(payload) {
  return WebServiceWrapper.Post("/patient/UnlockPatient", payload);
}
function GetPatientDataToExport(pid, exportType, userId, centerId) {
    const isAdmin = IsAdmin();
    return WebServiceWrapper.Get(`/patient/GetPatientDataToExport?patientId=${pid}&exportType=${exportType}&userId=${userId}&centerId=${centerId}&isAdmin=${isAdmin}`);
}

function SaveZipFile(payload) {
  return WebServiceWrapper.PostWithHeader("/patient/SaveZipFile", payload, undefined, { "Content-Type": "multipart/form-data", });
}
function SavePatient(payload) {
    return WebServiceWrapper.Post("/patient/SavePatient", payload);
}
function GetClinicalDates(pid) {
  const isAdmin= IsAdmin();
  return WebServiceWrapper.Get(`/patient/GetClinicalDates?patientId=${pid}&isAdmin=${isAdmin}`);
}

function DownloadFile(type) {
    return WebServiceWrapper.Get(`/patient/DownloadFile?type=${type}`);
}